import api from "./api";

// Capa de servicios API del dominio "listas de contactos" (contact-lists + contact-list-items)
// (FSD / capa API transversal). Wrappers de transporte finos: la construcción de payloads/params
// vive en el componente; aquí solo se centraliza el endpoint.

// --- Listas ---
export const listContactLists = (params) => api.get("/contact-lists/", { params });
export const listContactListsSimple = (params) =>
  api.get("/contact-lists/list", { params });
export const getContactList = (contactListId) =>
  api.get(`/contact-lists/${contactListId}`);
export const createContactList = (payload) => api.post("/contact-lists", payload);
export const updateContactList = (contactListId, payload) =>
  api.put(`/contact-lists/${contactListId}`, payload);
export const deleteContactList = (contactListId) =>
  api.delete(`/contact-lists/${contactListId}`);
// Importación masiva de contactos a una lista (multipart, timeout amplio).
export const uploadContactListFile = (contactListId, formData) =>
  api.request({
    url: `contact-lists/${contactListId}/upload`,
    method: "POST",
    data: formData,
    timeout: 30000,
  });

// --- Ítems de lista ---
export const listContactListItems = (params) =>
  api.get("/contact-list-items", { params });
export const getContactListItem = (contactId) =>
  api.get(`/contact-list-items/${contactId}`);
export const createContactListItem = (payload) =>
  api.post("/contact-list-items", payload);
export const updateContactListItem = (contactId, payload) =>
  api.put(`/contact-list-items/${contactId}`, payload);
export const deleteContactListItem = (contactId) =>
  api.delete(`/contact-list-items/${contactId}`);
